/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState,useContext } from "react";
import styles from "../css/SetupForm.module.css";
import { openDB } from "idb";
import Context from "../context/context";
const CheckboxInput = ({
  name,
  children,
  kotFieldCustomization,
  handleCheckboxChange,
}) => (
  <label className={styles.checkboxLabel}>
    <input
      name={name}
      type='checkbox'
      checked={+kotFieldCustomization[name] === 1}
      onChange={handleCheckboxChange}
    />
    {children}
  </label>
);

export default function KotFieldCustomizationForm({
  setCustomizationModalOpen,
  kotFieldCustomizations,
  setKotFieldCustomizations,
}) {
   const context = useContext(Context);
   const { updateUnSync } = context;

  const [kotFieldCustomization, setKotFieldCustomization] = useState(
    kotFieldCustomizations
  );
  useEffect(() => {
    const getData = () => {
      let DBOpenReq = indexedDB.open(
        "FoodDo",
        +localStorage.getItem("IDBVersion") || 1
      );
      DBOpenReq.addEventListener("error", (err) => {
        console.warn(err);
      });
      DBOpenReq.addEventListener("success", (ev) => {
        let tx = ev.target.result.transaction("outlet", "readwrite");
        let store = tx.objectStore("outlet");
        let getReq = store.getAll();
        getReq.onsuccess = (outletReq) => {
          var outlet = outletReq.target.result[0];

          if (outlet.kot_setup.kot_field_customization) {
            setKotFieldCustomization({
              ...kotFieldCustomizations,
              ...outlet.kot_setup.kot_field_customization,
            });
          }
        };
      });
    };
    getData();
  }, []);

  console.log(kotFieldCustomization);

  const handleCheckboxChange = (event) => {
    const { checked, name } = event.target;
    setKotFieldCustomization({
      ...kotFieldCustomization,
      [name]: +checked ? 1 : 0,
    });
  };

  const handleSelectChange = (event) => {
    const { value, name } = event.target;
    setKotFieldCustomization({
      ...kotFieldCustomization,
      [name]: value,
    });
  };

  const checkboxArgs = {
    kotFieldCustomization,
    setKotFieldCustomization,
    handleCheckboxChange,
  };

  const formSubmits = async (e) => {
    e.preventDefault();
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const outletStore = db
      .transaction("outlet", "readwrite")
      .objectStore("outlet");
    let outlet = (await outletStore.getAll())[0];
    if (outlet.kot_setup.kot_field_customization) {
      outlet.kot_setup.kot_field_customization = {
        ...outlet.kot_setup.kot_field_customization,
        ...kotFieldCustomization,
      };
    }
    setKotFieldCustomizations({
      ...kotFieldCustomizations,
      ...kotFieldCustomization,
    });
    // console.log(outlet);
    await outletStore.put(outlet);
    handleKOTUnsyncedFile(outlet);
    setCustomizationModalOpen(false);
  };

  // Adding/Editing KOT to unsynced_files collection in IndexedDB
  const handleKOTUnsyncedFile = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("unsynced_files", "readwrite")
      .objectStore("unsynced_files");
    const ndata = {
      IDENTIFIER: "kot_setup",
      RECON_TIME: Date.now(),
      kot_setup: { ...data.kot_setup },
    };
    await tx.put(ndata);
    handleKOTReconciliation(ndata);
    updateUnSync()
  };

  // Adding/Editing kot to reconciliation collection in IndexedDB
  const handleKOTReconciliation = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("reconciliation", "readwrite")
      .objectStore("reconciliation");
    const allReconRecords = await tx.getAll();

    const othersJsonExists = allReconRecords.find(
      (curr) => curr.IDENTIFIER === "others"
    );
    if (othersJsonExists) {
      const kot = othersJsonExists?.details?.filter(
        (entry) => entry.type !== "kot_setup"
      );
      const editData = {
        ...othersJsonExists,
        details: [
          ...kot,
          {
            type: "kot_setup",
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.put(editData);
    } else {
      const newdata = {
        IDENTIFIER: "others",
        details: [
          {
            type: "kot_setup",
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.add(newdata);
    }
  };

  return (
    <div className={styles.form}>
      <div className={styles.heading}>
        <h1>KOT Field Customization</h1>
      </div>

      <div className={styles.formContainer}>
        <div className={styles.formGroup}>
          <h2>Header Printing Options</h2>
          <div className={styles.row}>
            <CheckboxInput name='seat' {...checkboxArgs}>
              Seat
            </CheckboxInput>
            <CheckboxInput name='ticket_number' {...checkboxArgs}>
              Ticket Number
            </CheckboxInput>
            <CheckboxInput name='order_number' {...checkboxArgs}>
              Order Number
            </CheckboxInput>
            <CheckboxInput name='date' {...checkboxArgs}>
              Date
            </CheckboxInput>
          </div>
          <div className={styles.row}>
            <CheckboxInput name='time' {...checkboxArgs}>
              Time
            </CheckboxInput>
            <CheckboxInput name='payment_mode' {...checkboxArgs}>
              Payment Mode
            </CheckboxInput>
            <CheckboxInput name='cashier' {...checkboxArgs}>
              Cashier
            </CheckboxInput>
          </div>
        </div>

        <div className={styles.formGroup}>
          <h2>Customer Name Printing</h2>
          <div className={styles.row}>
            <CheckboxInput name='customer_name_dinein' {...checkboxArgs}>
              Dine in Order
            </CheckboxInput>
            <CheckboxInput name='customer_name_takeaway' {...checkboxArgs}>
              Take Away / Pickup Orders
            </CheckboxInput>
            <CheckboxInput name='customer_name_delivery' {...checkboxArgs}>
              Delivery Orders
            </CheckboxInput>
          </div>
          <div className={styles.row}>
            <CheckboxInput name='customer_name_zomato' {...checkboxArgs}>
              Zomato Orders
            </CheckboxInput>
            <CheckboxInput name='customer_name_swiggy' {...checkboxArgs}>
              Swiggy Orders
            </CheckboxInput>
          </div>
        </div>

        <div className={styles.formGroup}>
          <h2>Customer Mobile Printing</h2>
          <div className={styles.row}>
            <CheckboxInput name='customer_mobile_dinein' {...checkboxArgs}>
              Dine in Order
            </CheckboxInput>
            <CheckboxInput name='customer_mobile_takeaway' {...checkboxArgs}>
              Take away / Pickup Orders
            </CheckboxInput>
            <CheckboxInput name='customer_mobile_delivery' {...checkboxArgs}>
              Delivery Orders
            </CheckboxInput>
          </div>
          <div className={styles.row}>
            <CheckboxInput name='customer_mobile_zomato' {...checkboxArgs}>
              Zomato Orders
            </CheckboxInput>
            <CheckboxInput name='customer_mobile_swiggy' {...checkboxArgs}>
              Swiggy Orders
            </CheckboxInput>
          </div>
        </div>

        <div className={styles.formGroup}>
          <h2>Customer Address Printing</h2>
          <div className={styles.row}>
            <CheckboxInput name='customer_address_dinein' {...checkboxArgs}>
              Dine in Order
            </CheckboxInput>
            <CheckboxInput name='customer_address_takeaway' {...checkboxArgs}>
              Take away / Pickup Orders
            </CheckboxInput>
            <CheckboxInput name='customer_address_delivery' {...checkboxArgs}>
              Delivery Orders
            </CheckboxInput>
          </div>
          <div className={styles.row}>
            <CheckboxInput name='customer_adress_zomato' {...checkboxArgs}>
              Zomato Orders
            </CheckboxInput>
            <CheckboxInput name='customer_adress_swiggy' {...checkboxArgs}>
              Swiggy Orders
            </CheckboxInput>
          </div>
        </div>

        <div className={styles.formGroup}>
          <h2>Other Printing Options</h2>

          <div className={styles.row}>
            <CheckboxInput name='serial_number_in_items' {...checkboxArgs}>
              Serial No. in Items
            </CheckboxInput>
            <CheckboxInput name='total_item_quantity' {...checkboxArgs}>
              Total Item Qty
            </CheckboxInput>
            <CheckboxInput name='category_name' {...checkboxArgs}>
              Category Name
            </CheckboxInput>
            <CheckboxInput name='item_amount' {...checkboxArgs}>
              Item Amount
            </CheckboxInput>
          </div>

          <div className={styles.row}>
            <label className={styles.selectLabel} style={{ width: "50%" }}>
              Multi Serving Display
              <select
                name='multi_serving_display'
                className={styles.select}
                style={{ width: "100%" }}
                value={+kotFieldCustomization.multi_serving_display}
                onChange={handleSelectChange}>
                <option value={0}>Same Line</option>
                <option value={1}>Another Line</option>
              </select>
            </label>
          </div>
        </div>
        <button className={styles.submit} onClick={formSubmits}>
          Save changes
        </button>
      </div>
    </div>
  );
}
